'use client';

import classNames from 'classnames';
import { useId, useState } from 'react';
import { MaterialIcon } from '../../../components/MaterialIcon';
import { RawHtml } from '../../../components/RawHtml/RawHtml';
import { StaticText } from '../i18n';

interface HowToApplyProps {
  content: string;
  staticText: StaticText;
  forceExpanded?: boolean;
}

export const HowToApply: React.FC<HowToApplyProps> = ({
  content,
  staticText,
  forceExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(forceExpanded);
  const contentId = useId();

  if (!content) return null;

  const isExpanded = forceExpanded || expanded;

  return (
    <div>
      <button
        type="button"
        className="flex w-full items-center gap-1 text-left font-font-weight/bullet-1 text-font-size/bullet-1 leading-line-height/bullet-1 text-text/primary"
        aria-expanded={isExpanded}
        aria-controls={contentId}
        onClick={() => !forceExpanded && setExpanded((prev) => !prev)}
      >
        <MaterialIcon
          icon="expand_less"
          className={classNames('overflow-visible transition-transform', {
            'rotate-90': !isExpanded,
            'rotate-180': isExpanded,
          })}
        />
        <span
          className={classNames(
            'text-text-primary text-lg font-semibold leading-5',
          )}
        >
          {staticText.howToApply}
        </span>
      </button>
      {isExpanded && (
        <div
          id={contentId}
          className="mt-spacing/gap/soft-12px font-font-weight/body-2 text-font-size/body-2 leading-line-height/body-2-relaxed text-text/secondary"
        >
          <RawHtml content={content} className="break-words" />
        </div>
      )}
    </div>
  );
};
